/* Advertorial Promotion — CTA behavior (A/B test)
   The "Shop A3O™ Elemental Serum" CTA supports two behaviors, chosen from the
   Theme Editor (and served per variant by Intelligems):

     A (pdp)              → normal navigation to the product page.
     B (pdp_add_to_cart)  → add the product to the cart (subscription selling plan
                            when configured), navigate to the PDP, and open the cart
                            drawer on arrival (via a cross-page sessionStorage flag
                            read by cart-drawer-custom.js).

   QA override: ?cta_variant=a or ?cta_variant=b forces a behavior regardless of the
   Theme Editor setting. */
(function () {
  'use strict';

  var OPEN_DRAWER_FLAG = 'elm:advertorial-open-drawer';

  function getOverrideBehavior() {
    try {
      var value = new URLSearchParams(window.location.search).get('cta_variant');
      if (value === 'b') return 'pdp_add_to_cart';
      if (value === 'a') return 'pdp';
    } catch (error) {
      /* URLSearchParams unavailable — ignore */
    }
    return null;
  }

  function addToCart(variantId, sellingPlanId) {
    var item = { id: Number(variantId), quantity: 1 };
    if (sellingPlanId) item.selling_plan = Number(sellingPlanId);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart/add failed: ' + response.status);
      return response.json();
    });
  }

  function handleClick(event) {
    var cta = event.currentTarget;
    var behavior = getOverrideBehavior() || cta.getAttribute('data-cta-behavior') || 'pdp';

    // Variant A: let the anchor navigate normally (Intelligems still tracks the click).
    if (behavior !== 'pdp_add_to_cart') return;

    var variantId = cta.getAttribute('data-cta-variant-id');
    var productUrl = cta.getAttribute('data-cta-product-url') || cta.getAttribute('href');

    // Nothing to add (no product selected) — fall back to normal navigation.
    if (!variantId) return;

    event.preventDefault();

    // Guard against double taps while the add request is in flight.
    if (cta.dataset.ctaBusy === '1') return;
    cta.dataset.ctaBusy = '1';

    var sellingPlanId = cta.getAttribute('data-cta-selling-plan-id');

    addToCart(variantId, sellingPlanId)
      .catch(function (error) {
        // Best-effort: log but don't abort. Some store configs (selling plans, cart
        // transforms, Shopify Functions) can return a non-2xx status even when the
        // item was added — so we still open the drawer and let it reflect the real
        // cart state after navigation.
        console.error('[advertorial-promotion] add to cart returned an error', error);
      })
      .then(function () {
        // Flag the drawer to open on the PDP after attempting the add. Value is a
        // timestamp so the intent survives the theme's one-time post-add sync reload
        // (cart-drawer-custom.js re-opens the drawer on the reloaded page, within a
        // short TTL) instead of being consumed and lost on the first load.
        try { sessionStorage.setItem(OPEN_DRAWER_FLAG, String(Date.now())); } catch (error) { /* ignore */ }
        window.location.href = productUrl;
      });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var ctas = scope.querySelectorAll('.advertorial-promotion [data-advertorial-cta]');
    for (var i = 0; i < ctas.length; i++) {
      var cta = ctas[i];
      if (cta.dataset.ctaBound === '1') continue;
      cta.dataset.ctaBound = '1';
      cta.addEventListener('click', handleClick);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Re-bind when the section is re-rendered in the Theme Editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
